import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';
import { Icon } from '@iconify/react';

function EmailInbox() {
	const context = useContext(AppSettings);
	useEffect(() => {
		context.handleSetAppContentClass('p-0');
		context.handleSetAppContentFullHeight(true);
		return () => {
			context.handleSetAppContentClass('');
			context.handleSetAppContentFullHeight(false);
		};
	}, [context]);

	useEffect(() => {
		const onChange = (event) => {
			const checkbox = event.target;
			if (!checkbox.matches || !checkbox.matches('.mailbox-list input[type="checkbox"]')) return;
			const item = checkbox.closest('.mailbox-list-item');
			if (item) item.classList.toggle('selected', checkbox.checked);
			const label = checkbox.parentElement && checkbox.parentElement.querySelector('label');
			if (label) label.classList.toggle('active', checkbox.checked);
		};
		document.addEventListener('change', onChange);
		return () => document.removeEventListener('change', onChange);
	}, []);
	return (
		<>
			<div className="mailbox">
				<div className="mailbox-toolbar">
					<div className="mailbox-toolbar-item">
						<span className="mailbox-toolbar-text">{'Mailboxes'}</span>
					</div>
					<div className="mailbox-toolbar-item">
						<Link to="/email/inbox" className="mailbox-toolbar-link active">
							{'Inbox'}
						</Link>
					</div>
					<div className="mailbox-toolbar-item">
						<Link to="/email/inbox" className="mailbox-toolbar-link">
							{'Sent'}
						</Link>
					</div>
					<div className="mailbox-toolbar-item">
						<Link to="/email/inbox" className="mailbox-toolbar-link">
							{'Drafts (1)'}
						</Link>
					</div>
					<div className="mailbox-toolbar-item">
						<Link to="/email/inbox" className="mailbox-toolbar-link">
							{'Junk'}
						</Link>
					</div>
					<div className="mailbox-toolbar-item">
						<Link to="/email/compose" className="mailbox-toolbar-link">
							{'New Message'}
							<i className="fa fa-pen fs-12px ms-1"></i>
						</Link>
					</div>
				</div>
				<div className="mailbox-body">
					<div className="mailbox-sidebar">
						<div data-scrollbar="true" data-height="100%">
							<div className="mailbox-list">
								<div className="mailbox-list-item unread has-attachment">
									<div className="mailbox-checkbox">
										<div className="form-check">
											<input
												className="form-check-input"
												type="checkbox"
												value=""
												id="mailCheckbox1"
											/>
											<label className="form-check-label" htmlFor="mailCheckbox1"></label>
										</div>
									</div>
									<div className="mailbox-message">
										<Link to="/email/detail" className="mailbox-list-item-link">
											<div className="mailbox-sender">
												<span className="mailbox-sender-icon bg-dark text-light">
													<i className="fab fa-apple"></i>
												</span>
												<span className="mailbox-sender-name">{'Apple'}</span>
												<span className="mailbox-time">{'1 hour ago'}</span>
											</div>
											<div className="mailbox-title">{'Your payment is received'}</div>
											<div className="mailbox-desc">
												{
													'Praesent id pulvinar orci. Donec ac metus non ligula faucibus venenatis. Suspendisse tortor est, placerat eu dui sed...'
												}
											</div>
										</Link>
									</div>
								</div>
								<div className="mailbox-list-item unread has-attachment">
									<div className="mailbox-checkbox">
										<div className="form-check">
											<input
												className="form-check-input"
												type="checkbox"
												value=""
												id="mailCheckbox2"
											/>
											<label className="form-check-label" htmlFor="mailCheckbox2"></label>
										</div>
									</div>
									<div className="mailbox-message">
										<Link to="/email/detail" className="mailbox-list-item-link">
											<div className="mailbox-sender">
												<span className="mailbox-sender-icon">
													<img
														src="/color-admin/admin/react/assets/img/user/profile.jpg"
														alt="User profile"
														className="object-fit-cover"
													/>
												</span>
												<span className="mailbox-sender-name">{'Chance Graham'}</span>
												<span className="mailbox-time">{'5 hours ago'}</span>
											</div>
											<div className="mailbox-title">{'Trip to South America'}</div>
											<div className="mailbox-desc">
												{
													'Quisque luctus sapien sodales pulvinar porta. In pretium accumsan elit, vitae blandit arcu suscipit eu. Ut tortor libero, gravida ut nisl tincidunt, efficitur laoreet mauris.'
												}
											</div>
										</Link>
									</div>
								</div>
								<div className="mailbox-list-item has-attachment">
									<div className="mailbox-checkbox">
										<div className="form-check">
											<input
												className="form-check-input"
												type="checkbox"
												value=""
												id="mailCheckbox3"
											/>
											<label className="form-check-label" htmlFor="mailCheckbox3"></label>
										</div>
									</div>
									<div className="mailbox-message">
										<Link to="/email/detail" className="mailbox-list-item-link">
											<div className="mailbox-sender">
												<span className="mailbox-sender-icon bg-primary text-white">
													<i className="fab fa-paypal"></i>
												</span>
												<span className="mailbox-sender-name">{'Paypal Inc'}</span>
												<span className="mailbox-time">{'Aug 11'}</span>
											</div>
											<div className="mailbox-title">
												{'Important information about your order #019244'}
											</div>
											<div className="mailbox-desc">
												{
													'Waltz, bad nymph, for quick jigs vex! Fox nymphs grab quick-jived waltz. Brick quiz whangs jumpy veldt fox. Bright vixens jump; dozy fowl quack. Quick wafting zephyrs vex bold Jim. Quick zephyrs blow, vexing daft Jim.'
												}
											</div>
										</Link>
									</div>
								</div>
								<div className="mailbox-list-item">
									<div className="mailbox-checkbox">
										<div className="form-check">
											<input
												className="form-check-input"
												type="checkbox"
												value=""
												id="mailCheckbox4"
											/>
											<label className="form-check-label" htmlFor="mailCheckbox4"></label>
										</div>
									</div>
									<div className="mailbox-message">
										<Link to="/email/detail" className="mailbox-list-item-link">
											<div className="mailbox-sender">
												<span className="mailbox-sender-icon bg-dark text-light">{'F'}</span>
												<span className="mailbox-sender-name">{'Fitbit'}</span>
												<span className="mailbox-time">{'Aug 09'}</span>
											</div>
											<div className="mailbox-title">
												{'Stylish accessories for your Charge 2'}
											</div>
											<div className="mailbox-desc">
												{
													'How quickly daft jumping zebras vex. Two driven jocks help fax my big quiz. Quick, Baz, get my woven flax jodhpurs! "Now fax quiz Jack!" my brave ghost pled.'
												}
											</div>
										</Link>
									</div>
								</div>
								<div className="mailbox-list-item">
									<div className="mailbox-checkbox">
										<div className="form-check">
											<input
												className="form-check-input"
												type="checkbox"
												value=""
												id="mailCheckbox5"
											/>
											<label className="form-check-label" htmlFor="mailCheckbox5"></label>
										</div>
									</div>
									<div className="mailbox-message">
										<Link to="/email/detail" className="mailbox-list-item-link">
											<div className="mailbox-sender">
												<span className="mailbox-sender-icon bg-dark text-light">
													<i className="fab fa-apple"></i>
												</span>
												<span className="mailbox-sender-name">{'Apple'}</span>
												<span className="mailbox-time">{'Aug 09'}</span>
											</div>
											<div className="mailbox-title">{'Your invoice from Apple.'}</div>
											<div className="mailbox-desc">
												{
													'Flummoxed by job, kvetching W. zaps Iraq. Cozy sphinx waves quart jug of bad milk. A very bad quack might jinx zippy fowls.'
												}
											</div>
										</Link>
									</div>
								</div>
								<div className="mailbox-list-item">
									<div className="mailbox-checkbox">
										<div className="form-check">
											<input
												className="form-check-input"
												type="checkbox"
												value=""
												id="mailCheckbox6"
											/>
											<label className="form-check-label" htmlFor="mailCheckbox6"></label>
										</div>
									</div>
									<div className="mailbox-message">
										<Link to="/email/detail" className="mailbox-list-item-link">
											<div className="mailbox-sender">
												<span className="mailbox-sender-icon bg-red-600 text-white">{'H'}</span>
												<span className="mailbox-sender-name">{'Hotels.com'}</span>
												<span className="mailbox-time">{'Aug 09'}</span>
											</div>
											<div className="mailbox-title">
												{'[Ends tonight!] 48 Hour Sale - Save up to 50% + save an extra 10%'}
											</div>
											<div className="mailbox-desc">
												{
													'Phasellus vulputate, ligula ac hendrerit euismod, nunc metus maximus tellus, aliquam finibus justo lorem a augue.'
												}
											</div>
										</Link>
									</div>
								</div>
								<div className="mailbox-list-item">
									<div className="mailbox-checkbox">
										<div className="form-check">
											<input
												className="form-check-input"
												type="checkbox"
												value=""
												id="mailCheckbox7"
											/>
											<label className="form-check-label" htmlFor="mailCheckbox7"></label>
										</div>
									</div>
									<div className="mailbox-message">
										<Link to="/email/detail" className="mailbox-list-item-link">
											<div className="mailbox-sender">
												<span className="mailbox-sender-icon bg-green text-white">
													<i className="fab fa-google"></i>
												</span>
												<span className="mailbox-sender-name">{'Google Calendar'}</span>
												<span className="mailbox-time">{'Aug 08'}</span>
											</div>
											<div className="mailbox-title">
												{'Daily schedule on Tuesday, May 9, 2026'}
											</div>
											<div className="mailbox-desc">
												{
													'Suspendisse potenti. Praesent ac ullamcorper sem. Mauris luctus accumsan felis'
												}
											</div>
										</Link>
									</div>
								</div>
								<div className="mailbox-list-item">
									<div className="mailbox-checkbox">
										<div className="form-check">
											<input
												className="form-check-input"
												type="checkbox"
												value=""
												id="mailCheckbox8"
											/>
											<label className="form-check-label" htmlFor="mailCheckbox8"></label>
										</div>
									</div>
									<div className="mailbox-message">
										<Link to="/email/detail" className="mailbox-list-item-link">
											<div className="mailbox-sender">
												<span className="mailbox-sender-icon bg-blue text-white">
													<i className="fab fa-facebook-f"></i>
												</span>
												<span className="mailbox-sender-name">{'Facebook Blueprint'}</span>
												<span className="mailbox-time">{'Aug 08'}</span>
											</div>
											<div className="mailbox-title">{'April 2026 � Blueprint Highlights'}</div>
											<div className="mailbox-desc">
												{
													'Phasellus pretium viverra tortor, eu sagittis erat aliquam nec. Nunc et volutpat ligula. Duis viverra posuere enim, ac bibendum massa viverra id.'
												}
											</div>
										</Link>
									</div>
								</div>
								<div className="mailbox-list-item">
									<div className="mailbox-checkbox">
										<div className="form-check">
											<input
												className="form-check-input"
												type="checkbox"
												value=""
												id="mailCheckbox9"
											/>
											<label className="form-check-label" htmlFor="mailCheckbox9"></label>
										</div>
									</div>
									<div className="mailbox-message">
										<Link to="/email/detail" className="mailbox-list-item-link">
											<div className="mailbox-sender">
												<span className="mailbox-sender-icon bg-orange text-white">{'C'}</span>
												<span className="mailbox-sender-name">{'Customer Care'}</span>
												<span className="mailbox-time">{'Aug 08'}</span>
											</div>
											<div className="mailbox-title">
												{'Re: [Case #1567940] - Re: [Important] Exabytes'}
											</div>
											<div className="mailbox-desc">
												{'Nam imperdiet molestie arcu, et gravida quam lacinia lobortis.'}
											</div>
										</Link>
									</div>
								</div>
								<div className="mailbox-list-item">
									<div className="mailbox-checkbox">
										<div className="form-check">
											<input
												className="form-check-input"
												type="checkbox"
												value=""
												id="mailCheckbox10"
											/>
											<label className="form-check-label" htmlFor="mailCheckbox10"></label>
										</div>
									</div>
									<div className="mailbox-message">
										<Link to="/email/detail" className="mailbox-list-item-link">
											<div className="mailbox-sender">
												<span className="mailbox-sender-icon bg-light text-dark">{'F'}</span>
												<span className="mailbox-sender-name">{'Flight Status'}</span>
												<span className="mailbox-time">{'Aug 07'}</span>
											</div>
											<div className="mailbox-title">
												{'[Case#2017022137015743] *FLIGHT RETIMED* **MH2713/15JUL17**'}
											</div>
											<div className="mailbox-desc">
												{
													'Etiam condimentum orci ut velit suscipit, ut accumsan elit aliquet. Nulla cursus mi at augue vestibulum suscipit. Aenean ut risus euismod, laoreet justo non, convallis quam.'
												}
											</div>
										</Link>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="mailbox-content d-none d-xl-block">
						<div data-scrollbar="true" data-height="100%">
							<div className="mailbox-empty-message">
								<div className="mailbox-empty-message-icon">
									<Icon icon="solar:letter-opened-line-duotone" className="text-secondary d-block" style={{ fontSize: '128px' }} />
								</div>
								<div className="mailbox-empty-message-title">
									<div className="mb-1">{'No messages selected'}</div>
									<div>
										<small>{'Choose an email from the list to read its content.'}</small>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default EmailInbox;
